<template>
  <aside class="rail" aria-hidden="true">
    <div class="rail__line">
      <div class="rail__fill" :style="{ transform: `scaleY(${vp.progress})` }"></div>
    </div>
    <ol class="rail__ticks">
      <li v-for="c in chapters" :key="c.id" :class="{ on: active === c.id }">
        <a :href="'#' + c.id">
          <span class="dot"></span>
          <span class="lbl mono">{{ c.num }} · {{ c.label }}</span>
        </a>
      </li>
    </ol>
  </aside>
</template>

<script setup>
import { useViewport } from '../../composables/useViewport'
defineProps({ chapters: { type: Array, required: true }, active: { type: String, default: '' } })
const vp = useViewport()
</script>

<style scoped>
.rail {
  position: fixed;
  left: 26px;
  top: 50%;
  transform: translateY(-50%);
  z-index: 50;
  display: flex;
  gap: 14px;
  align-items: stretch;
  pointer-events: none;
}
.rail > * { pointer-events: auto; }

.rail__line {
  position: relative;
  width: 1px;
  background: rgba(255, 255, 255, 0.09);
}
.rail__fill {
  position: absolute;
  inset: 0;
  transform-origin: top;
  background: linear-gradient(180deg, var(--signal), var(--light));
  will-change: transform;
}

.rail__ticks {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.rail__ticks a {
  display: flex;
  align-items: center;
  gap: 9px;
  padding: 4px 0;
}
.dot {
  width: 5px;
  height: 5px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.22);
  transition: background 0.3s, box-shadow 0.3s, transform 0.3s;
  flex: none;
}
.lbl {
  font-size: 9px;
  letter-spacing: 0.16em;
  color: var(--text-faint);
  opacity: 0;
  transform: translateX(-6px);
  transition: opacity 0.3s, transform 0.3s, color 0.3s;
  white-space: nowrap;
}
.rail:hover .lbl { opacity: 1; transform: none; }
li.on .dot {
  background: var(--signal);
  box-shadow: 0 0 0 3px var(--signal-dim);
  transform: scale(1.25);
}
li.on .lbl { color: var(--signal); }

@media (max-width: 1180px) {
  .rail { display: none; }
}
</style>
